import { lazy } from 'react';
import { IRoute } from 'models/route';
import Loadable from 'components/Loadable';
import { ROLES } from 'models/Roles';

const ListQuestions = Loadable(
	lazy(() => import('modules/OnboardingQuestion/pages/ListQuestions')),
);
const AddQuestion = Loadable(
	lazy(() => import('modules/OnboardingQuestion/pages/AddQuestion')),
);

const UpdateQuestion = Loadable(
	lazy(() => import('modules/OnboardingQuestion/pages/UpdateQuestion')),
);

const ONBOARDING_QUESTION_ROUTES: IRoute[] = [
	{
		path: 'onboarding-question',
		element: ListQuestions,
		name: 'OnboardingQuestions',
		roles: [ROLES.ADMIN],
		private: true,
	},
	{
		path: 'onboarding-question/add',
		element: AddQuestion,
		name: 'Add Question',
		roles: [ROLES.ADMIN],
		private: true,
	},
	{
		path: 'onboarding-question/update/:questionId',
		element: UpdateQuestion,
		name: 'Add Question',
		roles: [ROLES.ADMIN],
		private: true,
	},
];

export default ONBOARDING_QUESTION_ROUTES;
